import Breadcrumb from './../components/BreadCrumb';
import ContactSection from './../sections/ContactSection';
import HeadingDetailsSection from './../sections/HeadingDetailsSection';

function ContactScreen() {
  return (
    <>
        <HeadingDetailsSection heading='Contact Us'>
          <Breadcrumb screen='Contact Us'/>
        </HeadingDetailsSection>
        <ContactSection/>
    </>
  );
}

export default ContactScreen;
